import { render, staticRenderFns } from "./FreeModal.vue?vue&type=template&id=5918ec8c&scoped=true"
import script from "./FreeModal.vue?vue&type=script&lang=js"
export * from "./FreeModal.vue?vue&type=script&lang=js"
import style0 from "./FreeModal.vue?vue&type=style&index=0&id=5918ec8c&lang=less&scoped=true"
import style1 from "./FreeModal.vue?vue&type=style&index=1&id=5918ec8c&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5918ec8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5918ec8c')) {
      api.createRecord('5918ec8c', component.options)
    } else {
      api.reload('5918ec8c', component.options)
    }
    module.hot.accept("./FreeModal.vue?vue&type=template&id=5918ec8c&scoped=true", function () {
      api.rerender('5918ec8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/globalModals/FreeModal.vue"
export default component.exports